/* GOS Product Reviews hub — type tabs, sport chips, search, sort and page numbers.
   No dependencies. Works on every card rendered by sections/gos-reviews-hub.liquid.
   Shareable views: ?type=comparison&sport=padel&q=nox&page=2 */
(function () {
  function norm(text) {
    return String(text || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
  }

  function init(root) {
    if (root._prReady) return;
    root._prReady = true;

    var grid = root.querySelector('[data-pr-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pr-card]'));
    var per = parseInt(root.getAttribute('data-per-page'), 10) || 9;
    var search = root.querySelector('[data-pr-search]');
    var sortSel = root.querySelector('[data-pr-sort]');
    var typeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pr-type]'));
    var sportBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pr-sport]'));
    var pagesEl = root.querySelector('[data-pr-pages]');
    var rangeEl = root.querySelector('[data-pr-range]');
    var totalEl = root.querySelector('[data-pr-total]');
    var emptyEl = root.querySelector('[data-pr-empty]');
    var resetBtn = root.querySelector('[data-pr-reset]');
    var controls = root.querySelector('.pg-controls');

    var TYPES = ['all', 'review', 'comparison', 'top'];
    var state = { q: '', type: 'all', sport: 'all', sort: 'latest', page: 1 };

    var params = new URLSearchParams(window.location.search);
    if (TYPES.indexOf(params.get('type')) !== -1) state.type = params.get('type');
    if (params.get('sport')) state.sport = params.get('sport');
    if (params.get('q')) state.q = params.get('q');
    if (params.get('sort') === 'oldest') state.sort = 'oldest';
    if (parseInt(params.get('page'), 10) > 1) state.page = parseInt(params.get('page'), 10);
    if (search && state.q) search.value = state.q;
    if (sortSel) sortSel.value = state.sort;

    cards.forEach(function (c) {
      c._prSearch = norm(c.getAttribute('data-search'));
      c._prDate = +c.getAttribute('data-date') || 0;
    });

    // Hero counters: totals per type
    Array.prototype.forEach.call(root.querySelectorAll('[data-pr-stat]'), function (el) {
      var t = el.getAttribute('data-pr-stat');
      el.textContent = cards.filter(function (c) { return c.getAttribute('data-type') === t; }).length;
    });

    // Hide sport chips that have no articles at all
    sportBtns.forEach(function (b) {
      var id = b.getAttribute('data-pr-sport');
      if (id === 'all') return;
      b.hidden = !cards.some(function (c) { return c.getAttribute('data-sport') === id; });
    });

    function matches(c, skipType, skipSport) {
      if (!skipType && state.type !== 'all' && c.getAttribute('data-type') !== state.type) return false;
      if (!skipSport && state.sport !== 'all' && c.getAttribute('data-sport') !== state.sport) return false;
      var q = norm(state.q);
      if (q && c._prSearch.indexOf(q) === -1) return false;
      return true;
    }

    function setCount(btn, n) {
      var span = btn.querySelector('[data-pr-count]');
      if (span) span.textContent = n;
    }

    function syncUrl() {
      var p = new URLSearchParams();
      if (state.type !== 'all') p.set('type', state.type);
      if (state.sport !== 'all') p.set('sport', state.sport);
      if (state.q) p.set('q', state.q);
      if (state.sort !== 'latest') p.set('sort', state.sort);
      if (state.page > 1) p.set('page', state.page);
      var qs = p.toString();
      try { history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
    }

    function pageButton(label, page, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = label;
      if (opts.current) b.setAttribute('aria-current', 'page');
      if (opts.aria) b.setAttribute('aria-label', opts.aria);
      if (opts.arrow) b.className = 'pr-pages__arrow';
      b.addEventListener('click', function () {
        state.page = page;
        render();
        var top = (controls || grid).getBoundingClientRect().top + window.pageYOffset - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      return b;
    }

    function render() {
      typeBtns.forEach(function (b) {
        var id = b.getAttribute('data-pr-type');
        setCount(b, cards.filter(function (c) { return matches(c, true, false) && (id === 'all' || c.getAttribute('data-type') === id); }).length);
        b.setAttribute('aria-selected', id === state.type ? 'true' : 'false');
      });
      sportBtns.forEach(function (b) {
        var id = b.getAttribute('data-pr-sport');
        setCount(b, cards.filter(function (c) { return matches(c, false, true) && (id === 'all' || c.getAttribute('data-sport') === id); }).length);
        b.setAttribute('aria-pressed', id === state.sport ? 'true' : 'false');
      });

      var list = cards.filter(function (c) { return matches(c, false, false); });
      list.sort(function (a, b) { return state.sort === 'oldest' ? a._prDate - b._prDate : b._prDate - a._prDate; });

      var pages = Math.max(1, Math.ceil(list.length / per));
      if (state.page > pages) state.page = pages;
      var start = (state.page - 1) * per;
      var onPage = list.slice(start, start + per);

      cards.forEach(function (c) { c.hidden = true; });
      list.forEach(function (c) { grid.appendChild(c); });
      onPage.forEach(function (c) { c.hidden = false; });

      if (rangeEl) rangeEl.textContent = list.length ? (start + 1) + '–' + (start + onPage.length) : '0';
      if (totalEl) totalEl.textContent = list.length;
      grid.hidden = list.length === 0;
      if (emptyEl) emptyEl.hidden = list.length !== 0;

      if (pagesEl) {
        pagesEl.innerHTML = '';
        if (pages > 1) {
          if (state.page > 1) pagesEl.appendChild(pageButton('‹', state.page - 1, { arrow: true, aria: 'Previous page' }));
          for (var i = 1; i <= pages; i++) pagesEl.appendChild(pageButton(String(i), i, { current: i === state.page, aria: 'Page ' + i }));
          if (state.page < pages) pagesEl.appendChild(pageButton('›', state.page + 1, { arrow: true, aria: 'Next page' }));
        }
      }
      syncUrl();
    }

    typeBtns.forEach(function (b) { b.addEventListener('click', function () { state.type = b.getAttribute('data-pr-type'); state.page = 1; render(); }); });
    sportBtns.forEach(function (b) { b.addEventListener('click', function () { state.sport = b.getAttribute('data-pr-sport'); state.page = 1; render(); }); });
    if (search) search.addEventListener('input', function () { state.q = search.value; state.page = 1; render(); });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.page = 1; render(); });
    if (resetBtn) resetBtn.addEventListener('click', function () {
      state = { q: '', type: 'all', sport: 'all', sort: state.sort, page: 1 };
      if (search) search.value = '';
      render();
    });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pr-hub]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
